import { faker } from '@faker-js/faker'
import { getLast12MonthsDates } from './utils'
import { UsageCostAugmentedEntry, UsageCostResponseBody } from '../types'

export const generateLast12MonthsUsageCost = (): UsageCostResponseBody => {
    const months = getLast12MonthsDates()

    const data = months.map((date) => generateRandomUsageCost(date))
    data[0].cost.baselineCost = 10
    data[1].cost.baselineCost = 20
    data[data.length - 1].cost.baselineCost = 10
    data[data.length - 2].cost.baselineCost = 20

    return {
        totalItems: data.length,
        totals: {
            cost: {
                unit: '$',
            },
            usage: {
                unit: 'kWh',
            },
            demand: {
                unit: 'kw',
            },
        },
        items: data,
    }
}

export const generateRandomUsageCost: (
    date: string
) => UsageCostAugmentedEntry = (date) => {
    const supply = faker.number.int({
        min: 1000,
        max: 5000,
    })

    const transmission = faker.number.int({
        min: 1000,
        max: 5000,
    })

    const capacity = faker.number.int({
        min: 1000,
        max: 5000,
    })

    const tariff = faker.number.int({
        min: 1000,
        max: 5000,
    })

    const cpncp = faker.number.int({
        min: 1000,
        max: 5000,
    })

    const billingDemand = faker.number.int({
        min: 1000,
        max: 5000,
    })

    const taxes = faker.number.int({
        min: 1000,
        max: 5000,
    })

    const other = faker.number.int({
        min: 1000,
        max: 5000,
    })

    const totalCommodityCost = supply + transmission + capacity
    const totalTransportCost = tariff + cpncp + billingDemand
    const totalInvoiced =
        totalCommodityCost + totalTransportCost + taxes + other

    return {
        date: Date.parse(date),
        formattedDate: new Date(date).toISOString(),
        reportedUsns: faker.number.int({
            min: 1,
            max: 100,
        }),
        usage: {
            commodityUsage: faker.number.int({
                min: 1000,
                max: 5000,
            }),
            transportUsage: faker.number.int({
                min: 1000,
                max: 5000,
            }),
            unit: 'kWh',
        },
        cost: {
            totalInvoiced: totalInvoiced,
            commodity: {
                totalCommodityCost,
                supply,
                transmission,
                capacity,
            },
            transport: {
                totalTransportCost,
                tariff,
                '4cp4ncp': cpncp,
                billingDemand,
            },
            taxes,
            other,
            unit: '$',
        },
        demand: {
            actual: faker.number.int({
                min: 1000,
                max: 5000,
            }),
            billing: faker.number.int({
                min: 1000,
                max: 5000,
            }),
            unit: 'kw',
        },
    }
}
